// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sT_QPWovFh6VKaRsUuPX {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #c4c4c4;
}

.U_P7RvuFuuB2Bte5P4Zw {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
}

.kUWi1sal7EpiEKjB7flm {
  width: 400px;
  background: rgba(0, 0, 0, 0.6) !important;
}

.lUtip2nVMGqOA_uYIIPA {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.EqGLbucsZskoRDzt6P2B {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  column-gap: 32px;
}

.qXGR4IlfSFzoUNpbUJ4g {
  display: grid;
  grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);
  column-gap: 32px;
}

.xuK_9EtvPkRFyw4VXF_g {
  display: flex;
  flex-direction: row;
  flex: 2 1;
  column-gap: 32px;
}

.Fk4R8uSq3Iv86jcR_OAh {
  width: 152px;
}

.jmCa_IWPeFDrBkBZZIZK {
  min-height: 200px;
  width: 100%;
}

.QWZP1gpGLXidJ3FJnhEj {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  justify-content: end;
  border-top: 4px solid #c4c4c4;
  padding-top: 16px;
}

.q1AZ60sm7JCaVvpZdTSD {
  background-color: #D62828;
  color: white;
}
.q1AZ60sm7JCaVvpZdTSD:hover {
  color: white;
  border-color: #FCBF49;
}

.rA7esSB1i9NK_2GkYfw8 {
  flex-grow: 1;
}

.zgRdKDOReD8p0ErJ6qgt {
  margin-right: 64px;
}

.w3izEjdGadBlzMPUS2Ii {
  overflow-y: auto;
  display: flex;
  overflow-x: clip;
  flex-direction: column;
  max-height: calc(100vh - 16rem);
}

.RcVvGFkR_OJ2VpmZtOh5 {
  width: 30%;
}

.YVfu0AXrrSefgmTZRBby {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cQgDRk_eSfKAsGkw21HZ {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.MqWCvck_PdZyIUFKU2Tw {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
}

.hDC4HIj_RgcSq4871uU8 {
  min-width: 150px;
}

.j0MjJys2tdr7wcAoUIru {
  max-height: 40vh;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/screens/IdoCreateOrEdit/IdoCreateOrEdit.module.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AADJ;;AAIA;EACI,YAAA;EACA,yCAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sFAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AADJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,YAAA;AAFJ;AAGI;EACI,YAAA;EACA,qBAAA;AADR;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,gBAAA;AAFJ","sourcesContent":["\r\n\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    justify-content: space-between;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-bottom: 1px solid #c4c4c4;\r\n}\r\n\r\n.idoHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 16px;\r\n}\r\n\r\n.tabSelector {\r\n    width: 400px;\r\n    background: rgba(0, 0, 0, 0.6) !important;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n}\r\n\r\n.editRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n    column-gap: 32px;\r\n}\r\n\r\n.stakerOptions {\r\n    display: grid;\r\n    grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);\r\n    column-gap: 32px;\r\n}\r\n\r\n.textAreaInputRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 2 1;\r\n    column-gap: 32px;\r\n}\r\n\r\n\r\n.checkboxContainer {\r\n    width: 152px;\r\n}\r\n\r\n.editorContainer {\r\n    min-height: 200px;\r\n    width: 100%;\r\n}\r\n\r\n.bottomActionContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n    justify-content: end;\r\n    border-top: 4px solid #c4c4c4;\r\n    padding-top: 16px;\r\n}\r\n\r\n.deleteButton {\r\n    background-color: #D62828;\r\n    color: white;\r\n    &:hover {\r\n        color: white;\r\n        border-color: #FCBF49;\r\n    }\r\n}\r\n\r\n.flexGrower {\r\n    flex-grow: 1;\r\n}\r\n\r\n.bottomActionButtonContainer {\r\n    margin-right: 64px;\r\n}\r\n\r\n.idoInputContainer {\r\n    overflow-y: auto;\r\n    display: flex;\r\n    overflow-x: clip;\r\n    flex-direction: column;\r\n    max-height: calc(100vh - 16rem);\r\n}\r\n\r\n.buttonContainer {\r\n    width: 30%;\r\n}\r\n\r\n.deleteIdoModalOverlay {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.deleteIdoModal {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.deleteRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-top: 32px    ;\r\n}\r\n\r\n.selectInputContainer {\r\n    min-width: 150px;\r\n}\r\n\r\n.jsonContainer {\r\n    max-height: 40vh;\r\n    overflow-y: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `sT_QPWovFh6VKaRsUuPX`,
	"idoHeader": `U_P7RvuFuuB2Bte5P4Zw`,
	"tabSelector": `kUWi1sal7EpiEKjB7flm`,
	"editIDOContainer": `lUtip2nVMGqOA_uYIIPA`,
	"editRow": `EqGLbucsZskoRDzt6P2B`,
	"stakerOptions": `qXGR4IlfSFzoUNpbUJ4g`,
	"textAreaInputRow": `xuK_9EtvPkRFyw4VXF_g`,
	"checkboxContainer": `Fk4R8uSq3Iv86jcR_OAh`,
	"editorContainer": `jmCa_IWPeFDrBkBZZIZK`,
	"bottomActionContainer": `QWZP1gpGLXidJ3FJnhEj`,
	"deleteButton": `q1AZ60sm7JCaVvpZdTSD`,
	"flexGrower": `rA7esSB1i9NK_2GkYfw8`,
	"bottomActionButtonContainer": `zgRdKDOReD8p0ErJ6qgt`,
	"idoInputContainer": `w3izEjdGadBlzMPUS2Ii`,
	"buttonContainer": `RcVvGFkR_OJ2VpmZtOh5`,
	"deleteIdoModalOverlay": `YVfu0AXrrSefgmTZRBby`,
	"deleteIdoModal": `cQgDRk_eSfKAsGkw21HZ`,
	"deleteRow": `MqWCvck_PdZyIUFKU2Tw`,
	"selectInputContainer": `hDC4HIj_RgcSq4871uU8`,
	"jsonContainer": `j0MjJys2tdr7wcAoUIru`
};
export default ___CSS_LOADER_EXPORT___;
